// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"831ff517","54":"1f6cb285","78":"1a2c6161","223":"339e7801","378":"56dbe3bd","400":"e3368cf9","506":"f9a260d4","602":"af41d841","775":"6ef65a3f","802":"09096c32"}[chunkId] + ".chunk.js";
};